<div class="page">
  <cap-power-bi-report [reportId]="reportId" [reportPage]="reportPage"></cap-power-bi-report>
</div>
